import { render, staticRenderFns } from "./InteractionStudioHomepage.vue?vue&type=template&id=4df954b2&"
import script from "./InteractionStudioHomepage.vue?vue&type=script&lang=js&"
export * from "./InteractionStudioHomepage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports